
import { BasicCustomCursor } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { TimeStringHelper } from "@goodgamestudios/core";
import { int } from "@goodgamestudios/math-utilities";
import { SFConstants } from "../../constants/SFConstants";
import { Poker2TournamentDataEvent } from "../../event/Poker2TournamentDataEvent";
import { TournamentTableVO } from "../../gamevo/TournamentTableVO";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2Screen } from "./Poker2Screen";

import DisplayObject = createjs.DisplayObject;
import MouseEvent = createjs.MouseEvent;

export class Poker2TourTablesScreen extends Poker2Screen {
    public static NAME: string = "Poker2TourTablesScreen";

    private selectedLine: Library.PokerInterface.TourTableLine;
    private selectedTable: number = 0;
    private waitingForTableData: boolean = false;

    private MAX_LINES: number = 15;

    private currentSort: number = 0;

    constructor(disp: DisplayObject) {
        CONSTRUCTOR_HACK;
        super(disp);
    }

    private initComponents(): void {
        this.initTextFields();
        this.setHelperProperties();
    }

    private initTextFields(): void {
        this.tourTablesScreen.txt_tables.text = Poker2Model.languageData.getTextById("lobby_tables");
        this.tourTablesScreen.txt_winners.text = Poker2Model.languageData.getTextById("lobby_winner");
        this.tourTablesScreen.txt_players.text = Poker2Model.languageData.getTextById("lobby_players");
        this.tourTablesScreen.txt_spectators.text = Poker2Model.languageData.getTextById("lobby_specs");
        this.tourTablesScreen.txt_tables.mouseEnabled = false;
        this.tourTablesScreen.txt_winners.mouseEnabled = false;
        this.tourTablesScreen.txt_players.mouseEnabled = false;
        this.tourTablesScreen.txt_spectators.mouseEnabled = false;
        this.tourTablesScreen.btn_spectate.minWidth = 20;
        this.tourTablesScreen.btn_spectate.label = Poker2Model.languageData.getTextById("lobby_tour_watch");
        //tourTablesScreen.btn_refresh.x = tourTablesScreen.btn_spectate.x - (tourTablesScreen.btn_spectate.width + tourTablesScreen.btn_refresh.width);

        this.tourTablesScreen.btn_back.label = Poker2Model.languageData.getTextById("generic_btn_goback");
    }

    public show(): void {
        this.waitingForTableData = true;
        this.tourTablesScreen.btn_spectate.enableButton = false;
        this.controller.addEventListener("tournamentTableList", this.bindFunction(this.onTournamentTableList));
        super.show();
        this.initComponents();

        TableHeadButtonHelper.setHeadButtonsSizes([1.17, 1.86, 0.94, 1.23], this.tourTablesScreen);
    }

    public hide(): void {
        this.waitingForTableData = false;
        this.selectedLine = null;
        this.controller.removeEventListener("tournamentTableList", this.bindFunction(this.onTournamentTableList));
        super.hide();
    }

    private onTournamentTableList(event: Poker2TournamentDataEvent): void {
        this.waitingForTableData = false;
        this.fillTables(Poker2Model.tournamentData.tournamentTables);
        this.updateTournamentStats();
    }

    private updateTournamentStats(): void {
        this.tourTablesScreen.txt_pot.text = Poker2Model.languageData.getTextById("lobby_pot_total", [Poker2Model.tournamentData.tournamentPot]);
        var tournamentName: string = Poker2Model.tournamentData.getTournamentNameById(Poker2Model.tournamentData.selectedTournament);
        this.tourTablesScreen.txt_title.text = Poker2Model.languageData.getTextById("lobby_tournament", [tournamentName]);
        this.tourTablesScreen.txt_remaining.text = Poker2Model.languageData.getTextById("lobby_remaining_players", [Poker2Model.tournamentData.
            remainingPlayers, Poker2Model.tournamentData.allPlayers]);
        var timeNextRound: string = TimeStringHelper.getTimeToString(Poker2Model.tournamentData.nextRoundTime, TimeStringHelper.TWO_TIME_FORMAT,
            Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
        this.tourTablesScreen.txt_next_round.text = Poker2Model.languageData.getTextById("lobby_next_round", [timeNextRound]);
    }

    protected onClick(event: MouseEvent): void {
        // warten auf antwort vom Server!
        if (instanceOfClass(event.target, "TextField")) return;

        if (this.waitingForTableData)
            return;
        if (!event.target.enabled)
            return;

        super.onClick(event);

        switch (event.target) {
            case this.tourTablesScreen.btn_spectate:
                this.layoutManager.state = 10;
                this.spectateTournamentTable();
                break;
            case this.tourTablesScreen.btn_tables:
                this.layoutManager.state = 11;
                break;
            case this.tourTablesScreen.btn_tournament:
            case this.tourTablesScreen.btn_back:
                this.layoutManager.state = 14;
                break;
            case this.tourTablesScreen.btn_sitngo:
                this.layoutManager.state = 17;
                break;
            case this.tourTablesScreen.sort_0:
            case this.tourTablesScreen.sort_1:
            case this.tourTablesScreen.sort_2:
            case this.tourTablesScreen.sort_3:
                this.currentSort = int(event.target.properties);
                this.refreshTableList(event.target.properties);

                // hgs HS859: erzwinge den anzeigewechsel, solange die maus über dem objekt bleibt
                (event.target as Library.PokerInterface.TabelButton).toggleDropDown();
                event.target.dispatchEvent(new MouseEvent(MouseEvent.ROLL_OUT));
                event.target.dispatchEvent(new MouseEvent(MouseEvent.ROLL_OVER));
                break;
            case this.tourTablesScreen.btn_refresh:
                this.refreshTableList(this.currentSort);
                break;
            case this.tourTablesScreen.btn_up:
                this.updateSettings(["up"]);
                break;
            case this.tourTablesScreen.btn_down:
                if (this.tourTablesScreen.btn_down.enabled)
                    this.updateSettings(["down"]);
                break;
            default:
                if (instanceOfClass(event.target, "TourTableLine")) {
                    var item: Library.PokerInterface.TourTableLine = event.target as Library.PokerInterface.TourTableLine;
                    this.selectedTable = int(item.properties);
                    this.activateTableLine(item);
                    this.tourTablesScreen.btn_spectate.enableButton = item.tablewinner == "";
                }
        }
    }

    private updateSettings(properties: any[]): void {
        this.waitingForTableData = true;

        var paramObject: any;
        paramObject = new Object();

        for (var i: number = 0; i < properties.length; i++) {
            paramObject[properties[i]] = 0;
        }
        paramObject["id"] = Poker2Model.tournamentData.selectedTournament;//Poker2Model.tournamentData.spectatorTournamentId
        BasicModel.smartfoxClient.sendMessage("jts", [JSON.stringify(paramObject)]);
    }

    private spectateTournamentTable(): void {
        this.waitingForTableData = true;
        var tournamentId: number = int(Poker2Model.tournamentData.selectedTournament);
        var paramObject: any = { tid: this.selectedTable, jid: tournamentId };
        BasicModel.smartfoxClient.sendMessage("jtj", [JSON.stringify(paramObject)]);
    }

    protected onMouseOver(event: MouseEvent): void {
        switch (event.target) {
            default:
                if (instanceOfClass(event.target, "TourTableLine")) {
                    var item: Library.PokerInterface.TourTableLine = castAs<Library.PokerInterface.TourTableLine>(event.target, "TourTableLine");

                    if (item != this.selectedLine)
                        item.mc_background.gotoAndStop(2);
                    this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_CLICK);
                }
        }
        super.onMouseOver(event);
    }

    protected onMouseOut(event: MouseEvent): void {
        switch (event.target) {
            default:
                if (instanceOfClass(event.target, "TourTableLine")) {
                    var item: Library.PokerInterface.TourTableLine = castAs<Library.PokerInterface.TourTableLine>(event.target, "TourTableLine");

                    if (item != this.selectedLine)
                        item.mc_background.gotoAndStop(1);
                    this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_ARROW);
                }
        }
        super.onMouseOut(event);
    }

    private fillTables(tables: TournamentTableVO[]): void {
        this.tourTablesScreen.btn_spectate.enableButton = false;

        if (tables.length < this.MAX_LINES)
            this.tourTablesScreen.btn_down.enableButton = false;
        else
            this.tourTablesScreen.btn_down.enableButton = true;

        for (var i: number = 0; i < this.MAX_LINES; i++) {
            var tItem: Library.PokerInterface.TourTableLine = this.tourTablesScreen["line" + i] as Library.PokerInterface.TourTableLine;

            if (tables.length - 1 < i) {
                tItem.visible = false;
                continue;
            }
            tItem.mc_background.gotoAndStop(1);
            tItem.visible = true;

            tItem.properties = tables[i].id;
            tItem.txt_tables.text = tables[i].tableName;
            tItem.txt_winners.text = tables[i].tableWinner;
            tItem.tablewinner = tables[i].tableWinner;
            tItem.txt_players.text = String(tables[i].currentPlayers);
            tItem.txt_spectators.text = String(tables[i].spectators);
            tItem.mouseChildren = false;
        }
        this.selectedLine = null;
    }

    private refreshTableList(sortIndex: number = 0): void {
        this.waitingForTableData = true;
        var tournamentId: number = int(Poker2Model.tournamentData.selectedTournament);
        var paramObject: any = { sort: sortIndex, id: tournamentId };
        BasicModel.smartfoxClient.sendMessage("jts", [JSON.stringify(paramObject)]);
    }

    private setHelperProperties(): void {
        for (var i: number = 0; i < 4; i++) {
            this.tourTablesScreen["sort_" + i].properties = i;
        }
    }

    private activateTableLine(table: Library.PokerInterface.TourTableLine): void {
        if (this.selectedLine != table) {
            if (this.selectedLine)
                this.selectedLine.mc_background.gotoAndStop(1);
            this.selectedLine = table;
            this.selectedLine.mc_background.gotoAndStop(2);
        }
    }

    public get tourTablesScreen(): Library.PokerInterface.PokerTournamentTables {
        return this.disp as Library.PokerInterface.PokerTournamentTables;
    }
}
import { Poker2LayoutManager } from "../Poker2LayoutManager";

import { castAs } from "@goodgamestudios/createjs-utilities";

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
import {TableHeadButtonHelper} from "../helper/TableHeadButtonHelper";
